import Splide from '@splidejs/splide';
import init from '../../../js/init';
import { Screen, Grid } from '../../../js/variables';

const name = 'slider';
const selector = '.slider';
const listSelector = `${selector}__list`;

init(Drupal, name, selector, (root, data) => {
  const slidesPerView = data.slidesPerView || 3;
  const pagination = !!data.pagination;
  const preview = !!data.preview;
  const previewSize = data.previewSize;

  const listElem = root.querySelector(listSelector);

  const slideCount = listElem.children.length;

  const config = {
    type: 'slide',
    pagination,
    speed: 450,
    perMove: 1,
    easing: 'cubic-bezier(0.33, 1, 0.68, 1)',
    mediaQuery: 'min',
    perPage: Math.min(slidesPerView, 1),
    gap: Grid.gutterWidth,
    breakpoints: {
      [Screen.sm]: {
        perPage: Math.min(slidesPerView, 2),
      },
      [Screen.md]: {
        perPage: Math.min(slidesPerView, 3),
      },
      [Screen.lg]: {
        perPage: slidesPerView,
      },
    },
  };

  if (preview) {
    config.padding = {
      left: '0',
      right: previewSize === 'small' ? '64px' : '20%',
    };
  }

  const splideObject = new Splide(root, config);
  splideObject.mount();

  splideObject.on('moved', (index, prev, dest) => {
    const event = new CustomEvent('slider-moved', {
      bubbles: true,
      detail: { current: index, previous: prev, dest },
    });
    root.dispatchEvent(event);
  });

  splideObject.on('move', (index, prev, dest) => {
    const event = new CustomEvent('slider-move', {
      bubbles: true,
      detail: { current: index, previous: prev, dest },
    });
    root.dispatchEvent(event);
  });

  root.addEventListener('next', () => {
    splideObject.go('>');
  });

  root.addEventListener('previous', () => {
    splideObject.go('<');
  });

  root.addEventListener('goto', ({ detail: { index } }) => {
    splideObject.go(index);
  });
});
